import { gql } from "@apollo/client";

// Export with both names for compatibility
export const getOtcSendRecipientFormConfigurationQuery = gql`
  query GetOtcSendRecipientFormConfiguration {
    getOtcSendRecipientFormConfiguration_Admin {
      banks {
        items {
          id
          longName
          shortName
          iconUrl
          iconRenderMode
          countryCode
          type
          fields {
            textFields {
              fieldName
              placeholderText
              labelText
              isRequired
              order
              keyboardType
            }
            dropdownFields {
              fieldName
              placeholderText
              labelText
              isRequired
              openType
              openTypeModalTitle
              openTypeSearchPlaceholderText
              options {
                displayName
                value
                iconUrl
                iconRenderMode
              }
              order
            }
          }
          subItems {
            fieldName
            placeholderText
            labelText
            isRequired
            openType
            openTypeModalTitle
            openTypeSearchPlaceholderText
            order
            options {
              displayName
              value
              iconUrl
              iconRenderMode
              fields {
                textFields {
                  fieldName
                  placeholderText
                  labelText
                  isRequired
                  order
                  keyboardType
                }
                dropdownFields {
                  fieldName
                  placeholderText
                  labelText
                  isRequired
                  openType
                  openTypeModalTitle
                  openTypeSearchPlaceholderText
                  options {
                    displayName
                    value
                    iconUrl
                    iconRenderMode
                  }
                  order
                }
              }
            }
          }
        }
      }
      eWallets {
        items {
          id
          longName
          shortName
          iconUrl
          iconRenderMode
          type
          fields {
            textFields {
              fieldName
              placeholderText
              labelText
              isRequired
              order
              keyboardType
            }
            dropdownFields {
              fieldName
              placeholderText
              labelText
              isRequired
              openType
              openTypeModalTitle
              openTypeSearchPlaceholderText
              options {
                displayName
                value
                iconUrl
                iconRenderMode
              }
              order
            }
          }
        }
      }
      stablecoins {
        items {
          id
          longName
          shortName
          iconUrl
          iconRenderMode
          type
          fields {
            textFields {
              fieldName
              placeholderText
              labelText
              isRequired
              order
              keyboardType
            }
            dropdownFields {
              fieldName
              placeholderText
              labelText
              isRequired
              openType
              openTypeModalTitle
              openTypeSearchPlaceholderText
              options {
                displayName
                value
                iconUrl
                iconRenderMode
              }
              order
            }
          }
        }
      }
    }
  }
`;

// Alias for compatibility with existing code
export const getAddSendFiatRecipientFormConfigurationAdminQuery = getOtcSendRecipientFormConfigurationQuery;

export const getOtcOrderQuery = gql`
  query GetOtcOrder($id: String!) {
    otcOrder_Admin(id: $id) {
      id
      customerId
      side
      currency
      amount
      debitAmountUsd
      transactionType
      status
      reference
      externalRef
      metadata
      recipientDetails
      settlementDetails
      settlementType
      fxRate
      quoteCurrency
      notes
      description
      createdBy
      completedBy
      cancelledBy
      createdAt
      updatedAt
      completedAt
      cancelledAt
      paymentCurrency
      paymentAmount
    }
  }
`;

export const completeOtcOrderWithFormMutation = gql`
  mutation CompleteOtcOrderWithForm($id: String!, $input: CompleteOtcOrderInput_Admin!) {
    completeOtcOrderWithForm_Admin(id: $id, input: $input) {
      id
      status
      side
    }
  }
`;
